/**
 * Created by kennethmwangi on 23/04/2017.
 */


import {Injectable} from "@angular/core";
import {Settings} from "../settings/base";
import {BaseService} from "./base-service";
import {Http} from "@angular/http";
@Injectable()
export class PatientService extends BaseService {


  constructor(private http: Http, private _settings: Settings) {

    super();
  }

  getPatients() {

    return this.http.get(this._settings.base_url + "patients/", this.createHeaders("Authorization"))
      .map(res => res.json());
  }

  getPatient(id) {
    return this.http.get(this.getPatientUrl(id), this.createHeaders("Authorization"))
      .map(res => res.json());
  }

  addPatient(patient) {
    return this.http.post(this._settings.base_url + "patients/", JSON.stringify(patient), this.createHeaders("Authorization"))
      .map(res => res.json());
  }

  updatePatient(patient) {
    return this.http.put(this.getPatientUrl(patient.id), JSON.stringify(patient), this.createHeaders("Authorization"))
      .map(res => res.json());
  }

  deletePatient(id) {
    return this.http.delete(this.getPatientUrl(id), this.createHeaders("Authorization"))
      .map(res => res.json());
  }

  getDoctorPatients(id) {
    return this.http.get(this._settings.base_url + "doctors/" + id + "/patients/", this.createHeaders("Authorization"))
      .map(res => res.json());
  }

  private getPatientUrl(id) {
    return this._settings.base_url + "patients/" + id + "/";

  }

  filterItems(searchTerm, patients) {

      return patients.filter((item) => {
        return item.patient_name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
      });

  }

}



// WEBPACK FOOTER //
// ./src/providers/patient-service.ts